module.exports = __webpack_public_path__ + "img/bsv.709dc32e.svg";